export default "__VITE_ASSET__DLTdmoa0__"